import ActualModel from '../Model';
export default class Model {
  callbacks = [];
  constructor(model) {
    this.model = model;
  }
  attribute(name, transform = null) {
    this.callbacks.push(() => {
      this.model.prototype[name] = transform ? ActualModel.attribute(name, transform) : ActualModel.attribute(name);
    });
    return this;
  }
  hasOne(name) {
    this.callbacks.push(() => {
      this.model.prototype[name] = ActualModel.hasOne(name);
    });
    return this;
  }
  hasMany(name) {
    this.callbacks.push(() => {
      this.model.prototype[name] = ActualModel.hasMany(name);
    });
    return this;
  }
  extend(app, extension) {
    for (const callback of this.callbacks) {
      callback.call(this);
    }
  }
}
flarum.reg.add('core', 'common/extenders/Model', Model);